import { createAction, handleActions } from "redux-actions";
import {
  _getAppointmentsList,
  _fetchAppointments,
  _getAllVenueList,
  _getAllAttendantList,
} from "~shared/httpService/apis";
import ActionTypes from "~shared/constants/actionTypes";
import { _getVenueListByPagination } from "../../../shared/httpService/apis";

const initialState = {
  appointments_list: {
    loading: false,
    response: [],
    hasError: false,
    error: {},
  },
  fetch_appointments_list: {
    loading: false,
    response: [],
    hasError: false,
    error: {},
  },
  venue_all_list: {
    loading: false,
    response: [],
    hasError: false,
    error: {},
  },
  venuelist_paginated: {
    loading: false,
    response: [],
    hasError: false,
    error: {},
  },
  attendant_list: { loading: false, response: [], hasError: false, error: {} },
};

// GET APPOINTMENT LIST
export const getAppointmentsListStart = createAction(
  ActionTypes.APPOINTMENTS_LIST
);
export const getAppointmentsListSuccess = createAction(
  ActionTypes.APPOINTMENTS_LIST_SUCCESS,
  (response) => response
);
export const getAppointmentsListError = createAction(
  ActionTypes.APPOINTMENTS_LIST_ERROR,
  (error) => error
);

export const getAppointmentsList =
  (pageNo, pageSize, startDate, endDate) => (dispatch) => {
    dispatch(getAppointmentsListStart());
    return _getAppointmentsList(pageNo, pageSize)
      .then((response) => {
        dispatch(getAppointmentsListSuccess(response));
      })
      .catch((error) => {
        dispatch(getAppointmentsListError(error));
      });
  };

// FILTER APPOINTMENTS
export const fetchAppointmentsStart = createAction(
  ActionTypes.FETCH_APPOINTMENTS_LIST
);
export const fetchAppointmentsSuccess = createAction(
  ActionTypes.FETCH_APPOINTMENTS_LIST_SUCCESS,
  (response) => response
);
export const fetchAppointmentsError = createAction(
  ActionTypes.FETCH_APPOINTMENTS_LIST_ERROR,
  (error) => error
);

export const fetchAppointments =
  (
    pageNo,
    pageSize,
    customerId,
    attendantId,
    venueId,
    selectedStatus,
    query,
    startDate,
    endDate,
    time_zones,
    petId,
    serviceId
  ) =>
  (dispatch) => {
    dispatch(fetchAppointmentsStart());
      return _fetchAppointments(
      pageNo,
      pageSize,
      customerId,
      attendantId,
      venueId,
      selectedStatus,
      query,
      startDate,
      endDate,
      time_zones,
      petId,
      serviceId
    )
      .then((response) => {
        dispatch(fetchAppointmentsSuccess(response));
      })
      .catch((error) => {
        dispatch(fetchAppointmentsError(error));
      });
  };

// VENUE LIST

export const getAllVenueListStart = createAction(
  ActionTypes.GET_ALL_VENUE_LIST
);
export const getAllVenueListSuccess = createAction(
  ActionTypes.GET_ALL_VENUE_LIST_SUCCESS,
  (response) => response
);
export const getAllVenueListError = createAction(
  ActionTypes.GET_ALL_VENUE_LIST_ERROR,
  (error) => error
);

export const getAllVenueList =
  (page = "", pageSize) =>
  (dispatch) => {
    dispatch(getAllVenueListStart());
    return _getAllVenueList(page, pageSize)
      .then((response) => {
        dispatch(getAllVenueListSuccess(response));
        return response;
      })
      .catch((error) => {
        dispatch(getAllVenueListError(error));
        throw error;
      });
  };

// GET_ALL_ATTENDANT_LIST
export const getAttendantListStart = createAction(
  ActionTypes.GET_ATTENDANT_LIST
);
export const getAttendantListSuccess = createAction(
  ActionTypes.GET_ATTENDANT_LIST_SUCCESS,
  (response) => response
);
export const getAttendantListError = createAction(
  ActionTypes.GET_ATTENDANT_LIST_ERROR,
  (error) => error
);

export const getAllAttendantList =
  (page = "", pageSize,search='') =>
  (dispatch) => {
    dispatch(getAttendantListStart());
    return _getAllAttendantList(page, pageSize, search)
      .then((response) => {
        dispatch(getAttendantListSuccess(response));
        return response;
      })
      .catch((error) => {
        dispatch(getAttendantListError(error));
        throw error;
      });
  };



  export const getVenueListStart = createAction(
    ActionTypes. GET_VENUE_LIST_PAGINATED
  );
  export const getVenueListSuccess = createAction(
    ActionTypes.GET_VENUE_LIST_PAGINATED_SUCCESS,
    (response) => response
  );
  export const getVenueListError = createAction(
    ActionTypes.GET_VENUE_LIST_PAGINATED_ERROR,
    (error) => error
  );



  //get all venue list by pagination
  export const getVenueListByPagination =
  (page = "", pageSize, inputName) =>
  (dispatch) => {
    dispatch(getVenueListStart());
    return _getVenueListByPagination(page, pageSize, inputName)
      .then((response) => {
        dispatch(getVenueListSuccess(response));
      })
      .catch((error) => {
        dispatch(getVenueListError(error));
      });
  };

const reducer = handleActions(
  {

     //VENUE LIST BY PAGINATION
     [ActionTypes.GET_VENUE_LIST_PAGINATED]: (state) => ({
      ...state,
      venuelist_paginated: {
        ...state.venuelist_paginated,
        loading: true,
        hasError: false,
        error: {},
      },
    }),
    [ActionTypes.GET_VENUE_LIST_PAGINATED_SUCCESS]: (state, action) => ({
      ...state,
      venuelist_paginated: {
        ...state.venuelist_paginated,
        response: action.payload,
        loading: false,
        hasError: false,
        error: {},
      },
    }),
    [ActionTypes.GET_VENUE_LIST_PAGINATED_ERROR]: (state, action) => ({
      ...state,
      venuelist_paginated: {
        ...state.venuelist_paginated,
        error: action.payload,
        loading: false,
        hasError: true,
      },
    }),
   
    //APPOINTMENT LIST
    [ActionTypes.APPOINTMENTS_LIST]: (state) => ({
      ...state,
      appointments_list: {
        ...state.appointments_list,
        loading: true,
        hasError: false,
        error: {},
      },
    }),
    [ActionTypes.APPOINTMENTS_LIST_SUCCESS]: (state, action) => ({
      ...state,
      appointments_list: {
        ...state.appointments_list,
        response: action.payload,
        loading: false,
        hasError: false,
        error: {},
      },
    }),
    [ActionTypes.APPOINTMENTS_LIST_ERROR]: (state, action) => ({
      ...state,
      appointments_list: {
        ...state.appointments_list,
        error: action.payload,
        loading: false,
        hasError: true,
      },
    }),

    //FETCH APPOINTMENT LIST
    [ActionTypes.FETCH_APPOINTMENTS_LIST]: (state) => ({
      ...state,
      fetch_appointments_list: {
        ...state.fetch_appointments_list,
        loading: true,
        hasError: false,
        error: {},
      },
    }),
    [ActionTypes.FETCH_APPOINTMENTS_LIST_SUCCESS]: (state, action) => {
     
      return{
      ...state,
      fetch_appointments_list: {
        ...state.fetch_appointments_list,
        response: action.payload,
        loading: false,
        hasError: false,
        error: {},
      },
  }
},
    [ActionTypes.FETCH_APPOINTMENTS_LIST_ERROR]: (state, action) => ({
      ...state,
      fetch_appointments_list: {
        ...state.fetch_appointments_list,
        error: action.payload,
        loading: false,
        hasError: true,
      },
    }),

    //VENUE_LIST
    [ActionTypes.GET_ALL_VENUE_LIST]: (state) => ({
      ...state,
      venue_all_list: {
        ...state.venue_all_list,
        loading: true,
        hasError: false,
        error: {},
      },
    }),
    [ActionTypes.GET_ALL_VENUE_LIST_SUCCESS]: (state, action) => ({
      ...state,
      venue_all_list: {
        ...state.venue_all_list,
        response: action.payload,
        loading: false,
        hasError: false,
        error: {},
      },
    }),
    [ActionTypes.GET_ALL_VENUE_LIST_ERROR]: (state, action) => ({
      ...state,
      venue_all_list: {
        ...state.venue_all_list,
        error: action.payload,
        loading: false,
        hasError: true,
        response: {},
      },
    }),

    //ATTENDANT_LIST
    [ActionTypes.GET_ATTENDANT_LIST]: (state) => ({
      ...state,
      attendant_list: {
        ...state.attendant_list,
        loading: true,
        hasError: false,
        error: {},
      },
    }),
    [ActionTypes.GET_ATTENDANT_LIST_SUCCESS]: (state, action) => ({
      ...state,
      attendant_list: {
        ...state.attendant_list,
        response: action.payload,
        loading: false,
        hasError: false,
        error: {},
      },
    }),
    [ActionTypes.GET_ATTENDANT_LIST_ERROR]: (state, action) => ({
      ...state,
      attendant_list: {
        ...state.attendant_list,
        error: action.payload,
        loading: false,
        hasError: true,
        response: {},
      },
    }),
  },
  initialState
);

export default reducer;
